import { createAction, props } from '@ngrx/store';
import { AssetSubscriptionV26 } from 'src/app/models-v26/asset-subscription-v26';
import { DeliveryItemV26 } from 'src/app/models-v26/deliveryitem-v26';
import { AddAssetOrderRequestV26 } from 'src/app/models-v26/wizards/add-asset-order-request-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { Desk } from 'src/app/models/desk';
import { CopyAssetDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/activation-step/copy-asset-due-date-info';
import { CopyAssetAdditionalInfoV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/additional-step/additional-info';
import { CopyAssetInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/init-step/init-step';

export const selectInitStep = createAction(
  '[V26 Asset Grid] Select Copy Init Information Step',
  props<{ initStep: CopyAssetInitStepV26 }>(),
);

export const selectAssetServicesInit = createAction(
  '[V26 Copy Asset Init Step] Select Asset Services Init Information Step',
  props<{ initAssetServiceStep: AssetSubscriptionV26[] }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Copy Asset Due Date Step] Select Due Date Step',
  props<{ dueDatesStep: CopyAssetDueDatesV26 }>(),
);

export const selectDeskStep = createAction('[V26 Copy Asset Desk Step] Select Desk Step', props<{ deskStep: Desk }>());

export const selectServiceStep = createAction(
  '[V26 Copy Asset Service Step] Select Service Information Step',
  props<{ serviceStep: DeliveryItemV26[] }>(),
);

export const deleteServiceStep = createAction('[V26 Copy Asset Service Step] Delete Service Information Step');

export const selectAdditionalStep = createAction(
  '[V26 Copy Asset AddInfo Step] Select Additional Information Step',
  props<{ addInfoStep: CopyAssetAdditionalInfoV26 }>(),
);

export const deleteAdditionalStep = createAction('[V26 Copy Asset AddInfo Step] Delete Additional Information Step');

export const exitCopyAssetWizard = createAction('[V26 Copy Asset Wizard Page] Exit Allocation Copy Asset Wizard');

export const destroyWizard = createAction('[V26 Copy Asset Wizard Page] Destroy Wizard');

export const createNewCopyAsset = createAction(
  '[V26 Copy Asset Confirmation Step] Copy Asset Information Step',
  props<{ newOrder: AddAssetOrderRequestV26 }>(),
);

export const createNewOrderSuccess = createAction(
  '[V26 Copy Asset Confirmation Step] Copy Asset Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewOrderFail = createAction(
  '[V26 Copy Asset Confirmation Step] Copy Asset Information Step Fail',
  props<{ errorMessage: string }>(),
);
